import { EnumUrlsPages } from '../../services/Enum';
import { IAmoSend } from './AmoCRM/Interfaces';
import { IAPISendEmail, IAPISendEmailContacts } from './Interfaces';

interface IFServerError {
  response: {
    status: number;
    data: any;
  };
  message: string;
}

export const GetServerTextError = (err: IFServerError) => {
  let message = '';
  switch (err.response.status) {
    case 400:
      err.response.data.message.forEach((item: string) => {
        message += `${item}<br>`;
      });
      break;
    case 401:
      message = err.response.data.message;
      break;
    default:
      message = err.message;
  }
  return message;
};

export const GetNamePage = () => {
  let namePage = 'Страница не определена';

  if (window.location.pathname.includes(EnumUrlsPages.vacancies)) {
    return 'Вакансии';
  }

  const blog = /\/(blog|news-company|news-mass-media|news-ecom-delivery|news)/.exec(window.location.pathname);
  if (blog) {
    return 'Блог';
  }

  switch (window.location.pathname) {
    case '/':
      namePage = 'Главная';
      break;
    case EnumUrlsPages.delivery:
    case EnumUrlsPages.deliveryMsk:
    case EnumUrlsPages.deliveryMskToSpb:
    case EnumUrlsPages.deliverySameDay:
    case EnumUrlsPages.deliveryShipFromStore:
    case EnumUrlsPages.deliveryRu:
    case EnumUrlsPages.deliveryPVZ:
    case EnumUrlsPages.deliveryOutsourcing:
    case EnumUrlsPages.deliveryComprehensiveService:
    case EnumUrlsPages.deliveryLogistics:
    case EnumUrlsPages.deliverySpb:
      namePage = 'Услуги';
      break;
    case EnumUrlsPages.calculator:
      namePage = 'Тарифы';
      break;
    case EnumUrlsPages.contacts:
      namePage = 'Контакты';
      break;
    case EnumUrlsPages.about:
      namePage = 'О компании';
      break;
    case EnumUrlsPages.tracking:
      namePage = 'Отслеживание';
      break;
    case EnumUrlsPages.vacancies:
      namePage = 'Вакансии';
      break;
    case EnumUrlsPages.reviews:
      namePage = 'Отзывы';
      break;
    case EnumUrlsPages.clients:
      namePage = 'Наши клиенты';
      break;
    case EnumUrlsPages.cashService:
      namePage = 'Кассовое обслуживание';
      break;
    case EnumUrlsPages.returnDocuments:
      namePage = 'Возврат документов';
      break;

    case EnumUrlsPages.gallery:
      namePage = 'Фотогалерея';
      break;
    case EnumUrlsPages.policy:
      namePage = 'Политика конфиденциальности';
      break;
    case EnumUrlsPages.questions:
      namePage = 'Частые вопросы';
      break;
    case EnumUrlsPages.docs:
      namePage = 'Документы';
      break;
    case EnumUrlsPages.integration:
      namePage = 'Интеграция';
      break;

    default:
      namePage = 'Страница не определена';
  }

  return namePage;
};

export const GetNameTitle = ({ eventMetrika }: { eventMetrika: string }) => {
  let title = 'Форма не определена';

  switch (eventMetrika) {
    case 'form_consult':
      title = 'Получить консультацию';
      break;
    case 'form_questions':
      title = 'Остались вопросы?';
      break;
    case 'form_club':
      title = 'Станьте участником клуба доставки Dalli';
      break;
    case 'form_team':
    case 'form_vacancy':
    case 'form_job':
      title = 'Стать частью команды';
      break;
    case 'form_contacts':
      title = 'Контакты (Остались вопросы?)';
      break;
    case 'form_feedback':
      title = 'Отзыв';
      break;
    case 'form_calc':
      title = 'Услуги (Получить расчет)';
      break;
    case 'form_kp_kass':
    case 'form_kp_docs':
    case 'form_kp_msk':
    case 'form_kp_msk_spb':
    case 'form_kp_spb':
    case 'form_kp_day':
    case 'form_kp_offline':
    case 'form_kp_russia':
    case 'form_kp_pvz':
    case 'form_kp_autsorsing':
    case 'form_kp_obsluzhivanie':
    case 'form_kp_logistika':
      title = 'Получите коммерческое предложение';
      break;
    case 'form_tracking':
      title = 'Отслеживание';
      break;
    case 'form_zoom':
      title = 'ZOOM с менеджером';
      break;
    case 'form_guide':
      title = 'Получите гайд в WhatsApp';
      break;
    case 'form_director':
      title = 'Написать коммерческому директору';
      break;
    case 'form_feedback_complaints':
      title = 'Обратная связь (Жалобы)';
      break;
    case 'form_partner':
      title = 'Стать партнером (Сотрудничество)';
      break;
    case 'form_letsgo':
      title = 'Главная (Оставьте заявку)';
      break;
    case 'form_header_connect':
      title = 'Шапка (Подключить доставку)';
      break;

    default:
      title = GetNamePage();
  }

  return title;
};

export const SetSeo = ({
  title,
  description,
  keywords,
}: {
  title: string;
  description: string;
  keywords: string;
}) => {
  const seo = { title, description };

  if (keywords) {
    return {
      ...seo,
      meta: {
        name: {
          keywords,
        },
      },
    };
  }

  return seo;
};
